/*
 * @Author: owen
 * @Date: 2022-04-07 10:51:44
 * @LastEditors: owen
 * @LastEditTime: 2022-04-20 14:37:21
 * @FilePath: \app-pcweb\src\router\index.js
 */
import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/lobby_common/store/index";
import LayoutMain from "@/layout/LayoutMain.vue";
import { hRoute } from "./h-router";
import AuthGuard from "./auth-guard";
import { killPlayerUser } from "@/lobby_common/api/game_gen";
import {
  getLocalStorage,
  removeLocalStorage,
  getSesStorage,
} from "@/lobby_common/utils/auth.js";
// import { isMobile } from "@/lobby_common/utils/utils";
import axios from "axios";
// import PayGame from "@/lobby_common/utils/payGame";
import { cacheKeys } from "@/lobby_common/utils/commonEnum.js";
import { payGameFun } from "@/lobby_common/utils/payGameFun.js";
import HomeSearchGame from "@/views/homeSearch/HomeSearchGame.vue";
import Home from "@/views/Home.vue";
// import {
//   getGameRewardList,
//   getPreviewRechargeReward,
// } from "@/lobby_common/utils/utils";
import telegramUtil from "@/lobby_common/utils/telegramUtil";
import Exposure from "@/lobby_common/utils/exposure.js";
import popConfig from "@/lobby_common/utils/popConfig.js";

const createDynamicComponent = (key, cmpt) => {
  return Vue.extend({
    name: key, // 防止key是关键字导致报错（例slot）
    components: {
      cmpt,
    },
    render(h) {
      return h(cmpt, { key: key + Date.now() });
    },
  });
};
const cacheArr = cacheKeys.map((key) => {
  return {
    path: "/" + key,
    name: key + "1",
    component: () => {
      return new Promise((resolve) => {
        resolve(createDynamicComponent(key + 1, HomeSearchGame));
      });
    },
  };
});

// 组件加载错误处理函数
const handleRouterError = (error, action = "push") => {
  console.error(`路由${action}错误:`, error);

  // 判断是否为组件加载失败错误
  const isComponentLoadError =
    error.message &&
    (error.message.includes("Loading chunk") ||
      error.message.includes("ChunkLoadError") ||
      error.message.includes("Loading CSS chunk") ||
      error.name === "ChunkLoadError" ||
      error.code === "MODULE_NOT_FOUND");

  if (isComponentLoadError) {
    // 避免频繁重新加载
    const lastReloadTime = localStorage.getItem("last_router_error_reload");
    const currentTime = Date.now();
    if (!lastReloadTime || currentTime - parseInt(lastReloadTime) > 3000) {
      localStorage.setItem("last_router_error_reload", currentTime.toString());

      console.log("由于组件加载失败，3秒后重新加载页面...");
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      console.log("最近刚刚重新加载过，跳过本次重新加载");
    }
  }

  return error;
};

// 获取原型对象上的push和replace函数
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush
    .call(this, location)
    .catch((err) => handleRouterError(err, "push"));
};

// 修改原型对象中的replace方法
VueRouter.prototype.replace = function replace(location) {
  return originalReplace
    .call(this, location)
    .catch((err) => handleRouterError(err, "replace"));
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: LayoutMain,
    redirect: "/home",
    children: [
      {
        path: "/home",
        // alias: '/',
        component: () => import("@/views/Home.vue"),
        name: "homeIndex",
        meta: {
          title: "route.home",
          noCache: true,
          affix: true,
          hideTGBack: true,
          // keepAlive: isMobile() ? true : true,
        },
      },
      {
        path: "/video",
        // alias: '/',
        component: () => import("@/views/video/index.vue"),
        name: "video",
        meta: {
          title: "route.video",
          noCache: true,
          affix: true,
          hideTGBack: true,
          // keepAlive: isMobile() ? true : true,
        },
      },
      {
        path: "/videoList",
        // alias: '/',
        component: () => import("@/views/videoList/index.vue"),
        name: "videoList",
        meta: {
          title: "route.video",
          noCache: true,
          affix: true,
          hideTGBack: true,
          // keepAlive: isMobile() ? true : true,
        },
      },
      {
        path: "/videoDetail",
        // alias: '/',
        component: () => import("@/views/videoDetail/index.vue"),
        name: "videoDetail",
        meta: {
          title: "route.video",
          noCache: true,
          affix: true,
          hideTGBack: true,
          // keepAlive: isMobile() ? true : true,
        },
      },
      {
        path: "/viceHome",
        component: () => {
          return new Promise((resolve) => {
            resolve(createDynamicComponent("viceHome", Home));
          });
        },
        name: "viceHome",
        meta: {
          title: "route.home",
          noCache: true,
          affix: true,
        },
      },
      {
        path: "/user",
        component: () => import("@/views/user/index"),
        name: "User",
        children: [
          // 账户信息
          {
            path: "",
            component: () => import("@/views/user/accountInfo"),
            name: "accountInfoIndex",
            meta: {
              title: "route.accountInfo",
              noCache: true,
              affix: true,
            },
            beforeEnter: AuthGuard,
          },
          {
            path: "/user/wallet",
            component: () => import("@/views/user/wallet"),
            name: "Wallet",
            meta: {
              title: "route.Wallet",
              noCache: true,
              affix: true,
            },
            beforeEnter: AuthGuard,
          },
          {
            path: "/user/gameRecord",
            component: () => import("@/views/user/GameRecord"),
            name: "GameRecord",
            meta: {
              title: "route.GameRecord",
              noCache: true,
              affix: true,
            },
            beforeEnter: AuthGuard,
          },
          {
            path: "/user/walletRecord",
            component: () => import("@/views/user/walletRecord"),
            name: "WalletRecord",
            meta: {
              title: "route.WalletRecord",
              noCache: true,
              affix: true,
            },
            beforeEnter: AuthGuard,
          },
          {
            path: "/user/vip",
            component: () => import("@/views/user/vip"),
            name: "vip",
            meta: {
              title: "route.vip",
              noCache: true,
              affix: true,
            },
            beforeEnter: AuthGuard,
          },
          {
            path: "/user/notice",
            component: () => import("@/views/user/noticePage"),
            name: "NoticePage",
            meta: {
              title: "route.NoticePage",
              noCache: true,
              affix: true,
            },
            beforeEnter: AuthGuard,
          },
          {
            path: "/user/distribution",
            component: () => import("@/views/user/distribution"),
            name: "distribution",
            meta: {
              title: "route.distribution",
              noCache: true,
              affix: true,
            },
            beforeEnter: AuthGuard,
          },
          {
            path: "/user/givingGift",
            component: () => import("@/views/user/givingGift"),
            name: "givingGift",
            meta: {
              title: "route.home_Gift",
              noCache: true,
              affix: true,
            },
            beforeEnter: AuthGuard,
          },
          {
            path: "/user/freeBet",
            component: () => import("@/views/freeBet/index.vue"),
            name: "freeBet",
            meta: {
              title: "route.app_free_BET",
              noCache: true,
              affix: true,
            },
            beforeEnter: AuthGuard,
          },
        ],
      },
      {
        path: "/events",
        component: () => import("@/views/events/index.vue"),
        name: "events",
        meta: {
          title: "route.accountInfo",
          noCache: true,
          affix: true,
        },
        // beforeEnter: AuthGuard,
      },
      {
        path: "/cooperation",
        component: () => import("@/views/cooperation/index.vue"),
        name: "cooperation",
        meta: {
          title: "route.cooperation",
          noCache: true,
          affix: true,
        },
        // beforeEnter: AuthGuard,
      },
      {
        path: "/reward",
        component: () => import("@/views/reward/index.vue"),
        name: "reward",
        meta: {
          title: "route.cooperation",
          noCache: true,
          affix: true,
        },
        // beforeEnter: AuthGuard,
      },
      {
        path: "/task",
        component: () => import("@/views/task.vue"),
        name: "task",
        meta: {
          title: "route.task",
          noCache: true,
          affix: true,
        },
        // beforeEnter: AuthGuard,
      },
      {
        path: "/activityDetail/:id?",
        component: () => import("@/views/activityDetail.vue"),
        name: "activityDetail",
        meta: {
          title: "route.activityDetail",
          noCache: true,
          affix: true,
        },
        // beforeEnter: AuthGuard,
      },
      ...cacheArr,
      {
        path: "/homeSearch",
        name: "homeSearch",
        component: () =>
          import(
            /* webpackChunkName: "HomeSearchGame" */ "@/views/homeSearch/HomeSearchGame.vue"
          ),
      },
      {
        path: "/gameList",
        name: "gameList",
        component: () =>
          import(
            /* webpackChunkName: "GameList" */ "@/views/gameList/index.vue"
          ),
      },
      {
        path: "/history",
        name: "history",
        component: () =>
          import(/* webpackChunkName: "History" */ "@/views/History.vue"),
        beforeEnter: AuthGuard,
      },
      {
        path: "/promote",
        name: "promote",
        component: () =>
          import(/* webpackChunkName: "Promotion" */ "@/views/Promotion.vue"),
      },
      {
        path: "/games/:gid/:canTestPlay?",
        component: () => import("@/components/payGame/index.vue"),
        name: "games",
        meta: {
          title: "route.payGame",
          noCache: true,
          affix: true,
        },
        beforeEnter: AuthGuard,
      },
      // 文档
      {
        path: "/policy/:type",
        name: "policy",
        component: () =>
          import(/* webpackChunkName: "Home" */ "@/views/policy/index.vue"),
      },
      // 排行榜
      {
        path: "/rankPage",
        component: () => import("@/views/rankPage.vue"),
        name: "rank",
        meta: {
          title: "route.rankPage",
          noCache: true,
          affix: true,
        },
        // beforeEnter: AuthGuard,
      },
    ],
  },
  // 充值教程详情
  {
    path: "/chargeTutorialDetail",
    component: () => import("@/components/charge/chargeTutorialDetail.vue"),
    name: "chargeTutorialDetail",
    meta: {
      title: "route.chargeTutorialDetail",
      noCache: true,
      affix: true,
      hiddenTabs: true,
      // hideTGBack: true,
    },
    // beforeEnter: AuthGuard,
  },
  {
    // path: "/other/:gid/:url",
    path: "/other/:gid",
    name: "otherGame",
    meta: {
      title: "route.payGame",
      noCache: true,
      affix: true,
      hiddenTabs: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "AccountInformation" */ "@/components/payGame/LayoutOther.vue"
      ),
    beforeEnter: AuthGuard,
  },
  {
    // 维护
    path: "/white",
    name: "white",
    meta: {
      hiddenTabs: true,
    },
    component: () => import("@/views/white.vue"),
  },
  // 403访问限制
  {
    path: "/403",
    name: "403",
    meta: {
      hiddenTabs: true,
      // hideTGBack: true,
    },
    component: () => import("@/views/error/403.vue"),
  },
  {
    path: "*",
    name: "404",
    meta: {
      hiddenTabs: true,
      // hideTGBack: true,
    },
    component: () => import("@/views/error/404.vue"),
  },
  // {
  //   path: "*", // 重定向页面地址
  //   redirect: "/",
  // },
  ...hRoute,
];

const router = new VueRouter({
  mode: "history",
  // mode: "hash", // hash/history
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    const el = document.querySelector(".el-main");
    if (el) {
      el.scrollTop = 0;
      window.scrollTo(0, 0);
    }
    return {
      // 也可以这么写
      // el: document.getElementById('main'),
      // selector: "#mainBox",
      top: -10,
    };
  },
});

// 添加全局路由错误处理器
router.onError((error) => {
  console.error("路由全局错误:", error);
  handleRouterError(error, "router");
});

router.beforeEach(async (to, from, next) => {
  // 判断是否为二级以上路由
  const hideTGBack = Boolean(to.meta.hideTGBack);
  // 解决浏览器缓存问题
  try {
    // 监听路由，作为一次曝光
    // console.log("======触发了路由跳转=====", to);
    Exposure.routerCacheData(to || {});
    const fromPath = from?.path || "";
    const toPath = to?.path || "";
    // 弹窗循环
    if (
      toPath.includes("/home") &&
      !toPath.includes("/homeSearch") &&
      fromPath !== "/" &&
      store.getters.taken
    ) {
      if (
        fromPath.includes("/other/") ||
        fromPath.includes("/games/") ||
        fromPath.includes("/payGame/")
      ) {
        popConfig?.initWinConfig(2);
      } else {
        popConfig?.initWinConfig(4);
      }
    }
    if (
      fromPath.includes("/other/") ||
      fromPath.includes("/games/") ||
      fromPath.includes("/payGame/")
    ) {
      if (
        toPath.includes("/other/") ||
        toPath.includes("/games/") ||
        toPath.includes("/payGame/")
      ) {
        //
      } else {
        store.dispatch("refreshPageApi", { type: "RefreshPageType_KillGame" }); // 刷新接口
        store.dispatch("getUserFirstWithdrawHintAction", {
          coinCode: store.getters.getPacketConfig?.appConfig?.coinCode,
        }); // 首提
        // 暂时注释：调救济金接口
        // try {
        //   const res = await previewEvent({ activity_type: 9 });
        //   if (res.code === 0) {
        //     store.commit("setReliefFunds", {
        //       shared: false,
        //       show: res.data?.can_receive,
        //       value: res.data?.data,
        //     });
        //   }
        // } catch (error) {
        //   //
        // }
      }
    }

    // let isLastGame = false;
    if (fromPath.includes("/games/") || fromPath.includes("/payGame/")) {
      if (toPath.includes("/other/") || !toPath.includes("/games/")) {
        if (store.getters.taken) {
          const res = await killPlayerUser({});
          window.sessionStorage.setItem("freeBetPopConfirm", "false"); // 重置游戏内提现弹窗状态
          if (res.code === 0) {
            const opt = res.data || {};
            if (opt.gameGroupSid !== "0") {
              // isLastGame = true;
              removeLocalStorage("currentGameStatus");
              payGameFun({ ...opt, KillOffType: true });
            }
          }
        }
      }
    }

    // 从其他页面跳到首页
    if (fromPath && fromPath !== "/" && fromPath !== "/home") {
      // console.log("======1111111=======", fromPath, toPath);
      // if (toPath === "/home") {
      // 首充、复充、破产引导
      if (
        fromPath.includes("/other/") ||
        fromPath.includes("/games/") ||
        fromPath.includes("/payGame/")
      ) {
        store.dispatch("getUserCoinsAsync"); // 从游戏退出更新钱包
        // 从游戏跳首页 没有首充、复充、破产引导 弹奖励提示弹窗
        // getPreviewRechargeReward(true);
      }
      // else {
      //   getPreviewRechargeReward();
      // }
      // }
      // 从游戏出来，不进入游戏, 也不进入首页
      // if (
      //   fromPath.includes("/other/") ||
      //   fromPath.includes("/games/") ||
      //   fromPath.includes("/payGame/")
      // ) {
      //   if (
      //     !toPath.includes("/other/") &&
      //     !toPath.includes("/games/") &&
      //     !toPath.includes("/payGame/") &&
      //     !toPath.includes("/home")
      //   ) {
      //     store.dispatch("getUserCoinsAsync"); // 从游戏退出更新钱包
      //     if (!isLastGame) {
      //       // 破产引导  或者 奖励提示 弹窗
      //       getGameRewardList("game");
      //     }
      //   }
      // }
    }

    const data = store.getters.getPacketConfig;
    // const adsEventConfig = store.getters.getAdsEventConfig;
    if (data?.code === 1050053 && to.path !== "/403") {
      next("/403");
    } else {
      if (hideTGBack) {
        telegramUtil.hideBackButton();
      } else {
        telegramUtil.showBackButton();
      }
      const newQuery = { ...to.query };
      let needsRedirect = false;
      if (window.kwai_pixel) {
        const kwai_obj = getLocalStorage("kwai_obj");
        if (kwai_obj?.click_id && kwai_obj?.pixel_id) {
          // 检查参数是否已存在
          if (!newQuery.click_id) {
            newQuery.click_id = kwai_obj.click_id;
            needsRedirect = true;
          }
          if (!newQuery.pixel_id) {
            newQuery.pixel_id = kwai_obj.pixel_id;
            needsRedirect = true;
          }
        }
        // console.log(JSON.stringify(newQuery) !== JSON.stringify(to.query))
        // 检查是否需要拼接
        if (
          needsRedirect &&
          JSON.stringify(newQuery) !== JSON.stringify(to.query)
        ) {
          console.log("Redirecting with query:", to.path, newQuery);
          next({ path: to.path, query: newQuery });
        } else {
          next(); // 继续导航
        }
      } else {
        next(); // 继续导航
      }
    }
  } catch (error) {
    console.error("导航守卫中发生错误", error);

    // 检查是否为组件加载错误
    const isComponentError =
      error.message &&
      (error.message.includes("Loading chunk") ||
        error.message.includes("ChunkLoadError"));

    if (isComponentError) {
      handleRouterError(error, "beforeEach");
      return; // 不调用next，等待页面重载
    }

    next(false); // 如果有错误，取消导航
  }
});

router.afterEach(async (to, from) => {
  if (
    from?.path.includes("/other/") ||
    from?.path.includes("/games/") ||
    from?.path.includes("/payGame/")
  ) {
    if (
      to?.path.includes("/other/") ||
      to?.path.includes("/games/") ||
      to?.path.includes("/payGame/")
    ) {
      //
    } else {
      // 退出游戏
      store.commit("setFullLayoutGame", false);
    }
  }
});
export default router;
